import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { optimizeName } from "../../other/vod-series-name-optimizer";
import DB from "../../other/local-db";

const RowItem = ({
  name,
  stream_icon,
  last,
  stream_id,
  category_id,
  id,
  style,
  isSeries,
}) => {
  const [noCover, setNoCover] = useState(!stream_icon);
  const [streamStat, setStreamStat] = useState();

  useEffect(() => {
    // Load stream statistics from DB
    setStreamStat(
      DB.findOne(
        isSeries ? "series" : "movie",
        stream_id,
        category_id === "fav"
      )
    );
  }, [isSeries, stream_id, category_id]);

  return (
    <Box
      component={Link}
      to={{
        pathname: `/${
          isSeries ? "series" : "movie"
        }/category/${category_id}/${stream_id}/info/`,
        search: window.location.search,
      }}
      data-id={id}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        textDecoration: "none",
        cursor: "pointer",
        width: "100%",
        height: "150px", // Smaller height
        pt: "0.2rem",
        pb: "0.2rem",
        boxSizing: "border-box",
        transition: "transform 0.3s ease",
        transformOrigin: "center center",
        "&:hover": {
          transform: "scale(1.2)",
          zIndex: 2,
        },
        ...(style || {}),
      }}
    >
      {/* Cover Image or Placeholder */}
      <Box
        sx={{
          width: "100%",
          height: "150px", // Adjusted for the smaller height
          backgroundColor: "#0c0f13", // Black background
          borderRadius: "4px", // Adjust border radius
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: "8px", // Padding around the image
        }}
      >
        {noCover ? (
          <Typography
            variant="h6"
            sx={{
              color: "white",
              textAlign: "center",
              fontSize: "0.75rem", // Smaller font size
            }}
          >
            {optimizeName(name)}
          </Typography>
        ) : (
          <Box
            component="img"
            src={stream_icon}
            alt={name}
            sx={{
              maxWidth: "100%", // Ensure image doesn't exceed container width
              maxHeight: "100%", // Ensure image doesn't exceed container height
              objectFit: "contain", // Contain ensures the entire image fits inside
              backgroundColor: "transparent",
            }}
            onError={() => setNoCover(true)} // Handle broken images
          />
        )}
      </Box>
    </Box>
  );
};

export default RowItem;
